<template>
  <div class="sub-page">
    <VolleyballSelect :componentName="componentName" @handleSelect="handleSelect" />
    <template v-if="scheduleList.length > 0">
      <div class="detail-list">
        <div class="detail-item" v-for="(item, index) in scheduleList" :key="index">
          <div class="date">{{ item.matchTime.slice(0, 14) }}</div>
          <div class="row" :class="index%2==1?'row-bg':''">
            <div class="left">
              <div class="info">{{ item.combatName }}</div>
              <div class="time">{{ item.matchTime.slice(14) }}</div>
            </div>
            <div class="center">
              <div class="bname" @click="handleBlue(item.redPeopleList, item.combatName)">
                <div>{{ item.redName }}</div>
                <img :src="item.redImg" alt="" />
              </div>
              <div class="score">
                <span>{{ item.redScore }}</span>
                <span>:</span>
                <span>{{ item.blueScore }}</span>
              </div>
              <div class="rname" @click="handleBlue(item.bluePeopleList, item.combatName)">
                <img :src="item.blueImg" alt="" />
                <div>{{ item.blueName }}</div>
              </div>
            </div>
            <div class="right">
              <div class="address">
                <a-icon type="environment" theme="filled" style="margin-top: -2px;margin-right: 5px;" /><span>{{
                  item.matchAddr
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AntdvPagination :total="total" :pageSize="queryVolleyParams.pageSize" :pageNum="queryVolleyParams.pageNum" v-if="total>scheduleList.length" @changePageNum="changePageNum"/>
    </template>
  
    <AntdvEmpty v-else />
    <!-- 队员弹窗 -->
    <a-modal v-model="visible" :title="combatName + '~参赛运动员'" :footer="null">
      <div class="player-model">
        <div class="team">
          <div class="team-name">参赛运动员</div>
          <div class="player-list">
            <div class="player-item" v-for="(player, index) in currentPlayerList" :key="index">
              <div class="player-box">
                <img :src="player.img" alt="" />
                <div class="name">{{ player.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import AntdvEmpty from '@comm/components/public/AntdvEmpty.vue'
import AntdvPagination from '@comm/components/public/AntdvPagination.vue'
import VolleyballSelect from './VolleyballSelect.vue'
export default {
  name: 'VolleyballSchedule',
  props: {
    componentName: {
      type: String,
      default: 'VolleyballSchedule',
    },
  },
  components: {
    AntdvEmpty,
    VolleyballSelect,
    AntdvPagination,
  },
  data() {
    return {
      teamIndex: 0,
      visible: false,
      combatName: '',
      currentPlayerList: [],
      detaillist: [
        {
          date: '03月01日 星期三',
          dataList: [
            {
              info: '小组赛 第一轮',
              time: '10:00',
              address: '比赛地点',
              redPlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 3,
              },
              bluePlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 5,
              },
            },
            {
              info: '小组赛 第二轮',
              time: '10:00',
              address: '比赛地点',
              redPlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 3,
              },
              bluePlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 5,
              },
            },
            {
              info: '小组赛 第三轮',
              time: '10:00',
              address: '比赛地点',
              redPlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 3,
              },
              bluePlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 5,
              },
            },
            {
              info: '小组赛 第四轮',
              time: '10:00',
              address: '比赛地点',
              redPlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 3,
              },
              bluePlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 5,
              },
            },
          ],
        },
        {
          date: '03月3日 星期五',
          dataList: [
            {
              info: '小组赛 第一轮',
              time: '10:00',
              address: '比赛地点',
              redPlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 3,
              },
              bluePlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 5,
              },
            },
            {
              info: '小组赛 第二轮',
              time: '10:00',
              address: '比赛地点',
              redPlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 3,
              },
              bluePlayers: {
                name: '代表队名称',
                image: require('../../../../assets/avatar.jpg'),
                score: 5,
              },
            },
          ],
        },
      ],
      queryVolleyParams: {
        pkRank: null,
        pageNum: 1,
        pageSize: 10,
        agencyId: null,
        matchId:this.$route.query.matchId
      },
      agencyId: null,
      scheduleList: [],
      total:0,
    }
  },
  mounted() {
    this.getQueryBigballV1()
  },
  methods: {
    //分页
    changePageNum(pageNum){
      this.queryVolleyParams.pageNum=pageNum
      this.getQueryBigballV1()
    },
    //选择赛程
    handleSelect(item,index){
      //index:1为轮次，2为球队，3性别 4项目
      switch(index){
        case 1:
          this.queryVolleyParams.pkRank=item
          break
        case 2:
          this.queryVolleyParams.agencyId=item
          break
      }
      this.getQueryBigballV1()
    },
    //获取排球赛程
    async getQueryBigballV1() {
      try {
        let res = await this.$api.district.queryBigballV1(this.queryVolleyParams)
        if (res.status == 0) {
          this.scheduleList = res.data
          this.total=res.total
        } else {
          this.message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleBlue(blueList, combatName) {
      this.visible = true
      this.combatName = combatName
      this.currentPlayerList = blueList
      console.log('handleBlue', blueList)
    },
    handleRed(redList, combatName) {
      this.visible = true
      this.combatName = combatName
      this.currentPlayerList = redList
      console.log('handleRed', redList)
    },
  },
  computed: {
    name2() {
      return 111
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .row-bg {
  background-color: #efefef;
}
// 对战弹窗
/deep/ .ant-modal {
  width: 800px !important;
}
/deep/ .ant-modal-content {
  border-radius: 10px !important;
  min-height: 200px;
  height: 400px !important;
}
/deep/ .ant-modal-header {
  border-radius: 10px 10px 0 0 !important;
}
.sub-page {
  color: #333333;
  padding-bottom: 30px;
  background-color: #F7F7F7;
  .ms-list {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    background-color: #ffffff;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    display: flex;
    justify-content: space-between;
    .right {
      width: 220px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #d3d3d3;
        font-weight: bold;
        cursor: pointer;
      }
      .div:hover {
        opacity: 0.8;
      }
    }
  }

  .detail-list {
    width: 1200px;
    margin: 0 auto;
    .detail-item {
      width: 100%;
      .date {
        padding-left: 30px;
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-weight: bold;
      }
      .row {
        padding-left: 30px;
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: space-between;
        background-color: #ffffff;
        align-items: center;
        margin-bottom: 10px;
        .left {
          .info {
            font-size: 14px;
            font-weight: bold;
          }
          .time {
            font-size: 20px;
            font-weight: bold;
          }
        }
        .center {
          display: flex;
          justify-content: space-between;
          .bname {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            img {
              width: 50px;
              height: 50px;
              margin-left: 10px;
              border-radius: 5px;
            }
          }
          .rname {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            img {
              width: 50px;
              height: 50px;
              margin-right: 10px;
              border-radius: 5px;
            }
          }
          .score {
            font-size: 22px;
            font-weight: bold;
            margin: 0 20px;
            text-align: center;
            padding-top: 10px;
          }
        }
        .right {
          width: 200px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          color: #999999;
          .address {
            font-size: 14px;
          }
        }
      }
      .row-bg{
        background-color: #E9E9E9;
      }
    }
  }
}
.player-model {
  width: 100%;
  height: 600px;
  overflow: auto;
  overflow-x: hidden;
  .team {
    color: #000000;
    width: 100%;

    .team-name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .player-list {
      width: 100%;
      // height: 120px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      box-sizing: border-box;
      margin-bottom: 20px;
      .player-item {
        width: 82px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .player-box {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          img {
            width: 70px;
            height: 70px;
            border-radius: 8px;
          }
          .name {
            font-size: 14px;
            font-weight: bold;
            margin-top: 5px;
          }
          .position {
            font-size: 14px;
          }
        }
      }
      .nomargin {
        margin-right: 0;
      }
      .player-item:last-child {
        margin-right: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballSchedule.vue